import apiClient from '@/shared/api/client'
import type { LoginRequest, TokenResponse, AccessTokenResponse, MeResponse, ChangePasswordRequest } from '@/shared/types/auth'

export const authApi = {
  login: async (data: LoginRequest): Promise<TokenResponse> => {
    const res = await apiClient.post<TokenResponse>('/auth/login', {
      username: data.username,
      password: data.password,
    })
    return res.data
  },

  refresh: async (refreshToken: string): Promise<AccessTokenResponse> => {
    const res = await apiClient.post<AccessTokenResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return res.data
  },

  logout: async (refreshToken?: string): Promise<void> => {
    await apiClient.post('/auth/logout', { refresh_token: refreshToken ?? '' })
  },

  me: async (): Promise<MeResponse> => {
    const res = await apiClient.get<MeResponse>('/auth/me')
    return res.data
  },

  changePassword: async (data: ChangePasswordRequest): Promise<{ ok: boolean }> => {
    const res = await apiClient.post<{ ok: boolean }>('/auth/change-password', {
      current_password: data.current_password,
      new_password: data.new_password,
    })
    return res.data
  },
}
